export default {
    MAIN_PLUGIN_KEY: 'syteSearch',
    CALLBACK_WRAPPER_NAME: 'onContentReadyForSyte',
    EVENTS_KEY: 'SyteEvents',
};
